import { Button, ButtonProps } from '@chakra-ui/react';
import styled from 'styled-components';

export const ChakraButton = styled(Button).attrs<ButtonProps>({
  w: {
    base: 'full',
    md: 'initial'
  }
} as ButtonProps)``;
